import {
    USER_LOGOUT, FETCH_ADMIN_USER_TIME_TRACKING,
    ADD_SELECTED_USER_TIME_TRACKING,REMOVE_SELECTED_USER_TIME_TRACKING,CLEAR_SELECTED_USER_TIME_TRACKING,

       }  from "actions/actionTypes";

var _ = require('lodash');

const initialState = {data: [], fetched:false, total:0,selectedRecords:[] };
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_ADMIN_USER_TIME_TRACKING:
            console.log('in FETCH_ADMIN_USER_TIME_TRACKING',action.payload );
             return {
                ...state,
                data: action.payload.data,
                total: action.payload.total,
                 fetched:true,
            }
        case REMOVE_SELECTED_USER_TIME_TRACKING:
            console.log('REMOVE_SELECTED_USER_TIME_TRACKING', state,  action.payload);
            var selectedRecordsToRemove =_.map( action.payload, function (product) {
                return product._id;
            });
            return {
                ...state,
                selectedRecords: _.uniq(_.difference(state.selectedRecords, selectedRecordsToRemove)),
            }
        case ADD_SELECTED_USER_TIME_TRACKING:
           // console.log('ADD_SELECTED_USER_TIME_TRACKING', state,  action.payload);
            var selectedRecordsToAdd =_.map( action.payload, function (product) {
                return product._id;
            });
            var updatedselectedRecords = _.uniq(state.selectedRecords.concat(selectedRecordsToAdd));
            return {
                ...state,
                selectedRecords: updatedselectedRecords
            }
        case CLEAR_SELECTED_USER_TIME_TRACKING:
            console.log('CLEAR_SELECTED_USER_TIME_TRACKING', state,  action.payload);
            return {
                ...state,
                selectedRecords: []
            }

        case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
}

export const getRecord = (state, id) => {
     return state.adminUsersData.data.filter(record => record._id === id)[0];
}